import { SquarePen } from "lucide-react";

import { useDispatch } from "react-redux";
import { showQuestionById } from "../../slices/dataSlice";

const AnswerBlockHeader = ({ question }) => {
  const dispatch = useDispatch();

  const handleEditClick = () => {
    dispatch(showQuestionById(question));
  };

  return (
    <div className="flex items-center justify-between mb-2 gap-4">
      <h3 className="text-sm font-semibold text-text-secondary">
        {question.category}
      </h3>
      <button
        className="p-1 bg-action-muted rounded-sm shadow hover:bg-action-muted-hover transition-colors"
        onClick={handleEditClick}
        aria-label={`Edit question in category ${question.category}`}
      >
        <SquarePen size={16} className="text-text-primary" aria-hidden="true" />
      </button>
    </div>
  );
};

export default AnswerBlockHeader;
